import { useEffect, useState } from 'react';
import { setPageLoaded } from 'Utils/analytics';

function useSegment(page, state) {
  const [pastPathname, setPastPathname] = useState('/');
  return useEffect(() => {
    const timer = setTimeout(() => {
      if (window?.analytics && page !== pastPathname) {
        setPageLoaded({
          page,
          isPreviousYear: state?.products?.isPreviousYear,
        });
        setPastPathname(page);
      }
    }, 1000);
    return () => clearTimeout(timer);
  }, [page]);
}

export default useSegment;
